import { forwardRef, useEffect, useState } from 'react';
import Input, { InputProps } from '.';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import pt from 'date-fns/locale/pt-BR';
import { formatDate } from '../../store/banner/utils';
registerLocale('pt', pt);

interface InputDatePickerProps extends InputProps {}
function maskDate(date: string): string {
  const numbers = date.replace(/\D/g, '');
  const truncatedNumbers = numbers.slice(0, 8);
  let formattedDate = '';
  for (let i = 0; i < truncatedNumbers.length; i++) {
    if (i === 2 || i === 4) {
      formattedDate += '/';
    }
    formattedDate += truncatedNumbers[i];
  }
  return formattedDate;
}

const CustomInput = forwardRef<any, any>(({ value, onClick, onBlur,...rest }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        textAlign: 'left',
        width: '100%',
      }}
      onClick={onClick}
    >
      <Input value={maskDate(value)} {...rest} />
    </div>
  );
});

function InputDatePicker({ value, onChange, disabled, ...rest }: InputDatePickerProps) {
  const [d, m, y] = value ? `${value}`.split('/') : [];
  const currentDate = new Date();
  const maxDate = new Date();
  maxDate.setFullYear(currentDate.getFullYear() + 1000);

  // useEffect(() => {
  //   value &&
  //     onChange &&
  //     onChange({ target: { value: `${d}/${m}/${y}` } } as any);
  // }, []);

  return (
    <DatePicker
      locale="pt"
      dateFormat="dd/MM/yyyy"
      selected={value ? new Date(`${m}/${d}/${y}`) : null}
      maxDate={maxDate}
      disabled={disabled}
      onChange={(date) => {
        onChange &&
          onChange({ target: { value: date ? formatDate(date) : '' } } as any);
      }}
      customInput={<CustomInput {...rest} />}
    />
  );
}

export default InputDatePicker;
